import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import DocumentScanner from '../../components/DocumentScanner';

export default function ScanBackPage({
    backImage,
    setBackImage,
    onNext,
    onPrev, // optional, wenn du einen "Zurück" Button brauchst
}) {
    const [hasScanned, setHasScanned] = useState(!!backImage);

    const handleCaptureComplete = (dataUrl) => {
        console.log("Rückseite erfasst:", dataUrl.length, "Zeichen");
        setBackImage(dataUrl);
        setHasScanned(true);
    };

    const handleRescan = () => {
        setBackImage(null);
        setHasScanned(false);
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                Schritt 2: Rückseite scannen
            </Typography>

            {!hasScanned ? (
                <DocumentScanner onCaptureComplete={handleCaptureComplete} />
            ) : (
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="body1" gutterBottom>
                        Folgendes Bild wurde erfasst (Rückseite):
                    </Typography>
                    <img
                        src={backImage}
                        alt="Rückseite"
                        style={{ maxWidth: '100%', border: '1px solid #ccc', borderRadius: 8 }}
                    />
                    <Box mt={2}>
                        <Button variant="outlined" onClick={handleRescan} sx={{ mr: 2 }}>
                            Erneut scannen
                        </Button>
                    </Box>
                </Box>
            )}

            <Box mt={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button variant="outlined" onClick={onPrev}>
                    Zurück
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    disabled={!backImage}
                    onClick={onNext}
                >
                    Weiter
                </Button>
            </Box>
        </Box>
    );
}
